module.exports = __webpack_public_path__ + "static/media/ddAudioBack.bcfb676.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ddAudioBack.mp3
// module id = bZUL
// module chunks = 12